// 统一处需要加密的接口CLIENTECTYPE66
import {
  interfaceEncryptionLists,
  interfaceEncryptionLists2,
  interfaceEncryptionLists3,
  interfaceEncryptionLists4
} from './CLIENTECTYPE66';
import { aesDeciphering, encryptJson } from '../globalFunction';

export const setConfig = (config) => {
  if(config&&config.url) {
    const isHave  = interfaceEncryptionLists.some(item=>{
      return config.url.includes(item)
    })
    const isHave2  = interfaceEncryptionLists2.some(item=>{
      return config.url.includes(item)
    })
    const isHave3  = interfaceEncryptionLists3.some(item=>{
      return config.url.includes(item)
    })
     const isHave4  = interfaceEncryptionLists4.some(item=>{
          return config.url.includes(item)
     })
    if(isHave4)  {
        config.params = {
            data: encryptJson(config.params)
        }
        return config
    }
    if(isHave) {
      config.headers['CLIENTECTYPE'] = 66
    }
    if(isHave3) {
      config.headers['CLIENTECTYPE'] = 65
    }
    if(isHave2) {
      config.headers['ENCRYPT'] = true
      config.params = {
        data: encryptJson(config.params)
      }
    }

  }
  return config
}

export const  setResponse = (response) => {
  let  config = response.config
  let res = response.data
  if(config&&config.url) {
    const isHave  = interfaceEncryptionLists.some(item=>{
      return config.url.includes(item)
    })
    if(isHave) {
      try {
        res.data = aesDeciphering(res.data)
      } catch (e) {

      }
    }
  }

  return response.data
}



// WEBPACK FOOTER //
// ./resources/js/config/axiosConfigSetting.js